export default __webpack_public_path__ + "static/media/right_character.d6972867.png";